var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ELink',{staticClass:"report-link",attrs:{"href":"#","rel":"noopener","target":"_self","data-test-id":"ad-report"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n  "+_vm._s(_vm.$t('common.search.ad.report'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }